export const genderOptions = [
  { value: "MALE", label: "Male", arabic_label: "ذكر" },
  { value: "FEMALE", label: "Female", arabic_label: "أنثى" },
];
export const maritalStatusOptions = [
  { value: "single", label: "Single", arabic_label: "أعزب" },
  { value: "married", label: "Married", arabic_label: "متزوج" },
];
export const militaryServiceOptions = [
  { value: "FINISHED", label: "Finished", arabic_label: "منتهية" },
  { value: "NOT_FINISHED", label: "Not Finished", arabic_label: "غير منتهية" },
  { value: "EXEMPTED", label: "Exempted", arabic_label: "معفى" },
];

export const requestedResumeLanguageOptions = [
  { value: "ARABIC", label: "Arabic", arabic_label: "العربية" },
  { value: "ENGLISH", label: "English", arabic_label: "الإنجليزية" },
];

export const photoIncludedOptions = [
  { value: "YES", label: "Yes", arabic_label: "نعم" },
  { value: "NO", label: "No", arabic_label: "لا" },
];

export const drivingLicenseOptions = [
  { value: "NONE", label: "None", arabic_label: "بدون" },
  { value: "TYPE_A", label: "Type A", arabic_label: "الفئة أ" },
  { value: "TYPE_B", label: "Type B", arabic_label: "الفئة ب" },
  { value: "TYPE_C", label: "Type C", arabic_label: "الفئة ج" },
  { value: "TYPE_D", label: "Type D", arabic_label: "الفئة د" },
];

// Desired Work Department
// Analysis/Statistic
// Telecommunications

// Desired Work Location
// Syria

// City
// Damascus

// Foreign Languages
// Arabic
// English

// Gender
// Female
// Male

// Military Service
// Not Specified
// Not Finished
// Finished

export const mockResumeData = {
  resume_id: "",
  account_photo: null,
  title: "",
  birthdate: "",
  city: "20", // Default to Damascus
  confidetial: 0,
  countryCode: "+963",
  country: "19", // Default to Syria
  driving_license: "TYPE_A",
  driving_license_date: "",
  gender: "MALE",
  full_name: "",
  nationality: "19", // Default to Syria (same as country)
  marital_status: "SINGLE",
  military_service: "FINISHED",
  military_service_date: "",
  title_id: "",
  phone_number: "",
};
